var indexOf = [].indexOf;

import {
  colorPickerColors
} from 'constants/colors';

angular.module('gym.calendar').controller('EditEventScheduleGeneralCtrl', ["$scope", "$rootScope", "$timeout", "$modalInstance", "FeatureAvailabilityService", "EditEventService", "EventService", "EventTypes", "TrainersService", "EmploymentService", "flash", "ConfirmLeaveUnsavedChangesService", "params", function($scope, $rootScope, $timeout, $modalInstance, FeatureAvailabilityService, EditEventService, EventService, EventTypes, TrainersService, EmploymentService, flash, ConfirmLeaveUnsavedChangesService, params) {
  var reloadEventTypes;
  $scope.gym = $rootScope.gym;
  $scope.event = params.event;
  $scope.classrooms = params.classrooms;
  $scope.styles = params.styles;
  $scope.eventTypes = params.eventTypes;
  $scope.permissions = EmploymentService.get().permissions;
  $scope.event.editScope = 'general';
  $scope.attendanceFeatureAvailable = FeatureAvailabilityService.isAvailable('attendance');
  $scope.trainers = TrainersService.get();
  $scope.unableToManageOtherContacts = !$scope.permissions.manage_other_contacts;
  $scope.displayRequireActiveMembershipDescription = function() {
    return EventService.displayRequireActiveMembershipDescription();
  };
  $scope.displayProximityCheckinDescription = function() {
    return EventService.displayProximityCheckinDescription();
  };
  $scope.setColor = function(color) {
    $scope.event.color = color;
    return $scope.event.customColor = void 0;
  };
  $scope.$on('colorpicker-closed', function(currentScope, color) {
    return $timeout(function() {
      return $scope.event.color = color.value;
    });
  });
  $scope.eventColors = colorPickerColors;
  $scope.isCustomColorSelected = function() {
    var ref;
    return $scope.event.color && (ref = $scope.event.color, indexOf.call($scope.eventColors, ref) < 0);
  };
  if ($scope.isCustomColorSelected()) {
    $scope.event.customColor = $scope.event.color;
  }
  ConfirmLeaveUnsavedChangesService.watch($scope, 'event', {
    closeModal: function() {
      return $scope.close(true);
    }
  });
  reloadEventTypes = function() {
    return EventService.eventTypesWithDeleted($scope.event.event_type_ids).then(function(types) {
      return $scope.eventTypes = types;
    });
  };
  $scope.manageTypes = function() {
    return EditEventService.manageTypes($scope.eventTypes).result.then(function() {
      return reloadEventTypes();
    }, function() {
      return reloadEventTypes();
    });
  };
  $scope.manageLocations = function() {
    return EditEventService.manageLocations($scope.classrooms).result.then(function() {
      return $scope.classrooms.reload();
    }, function() {
      return $scope.classrooms.reload();
    });
  };
  $scope.eventAppearanceTooltip = EventService.eventAppearanceTooltip();
  $scope.nameTooltip = EventService.nameTooltip();
  $scope.trainerTooltip = EventService.trainerTooltip();
  $scope.isValid = function() {
    var ref;
    return !$scope.isLoading && ((ref = $scope.event.name) != null ? ref.trim().length : void 0) && $scope.event.instructor_ids.length;
  };
  $scope.onClose = function() {
    params.cancelEdit();
    return $modalInstance.dismiss('cancel');
  };
  $scope.close = function(skipConfirmation) {
    if ($scope.displayConfirmationOnClose && !skipConfirmation) {
      if (window.confirm("Are you sure? This will abandon any unsaved changes.")) {
        return $scope.onClose();
      }
    } else {
      return $scope.onClose();
    }
  };
  return $scope.save = function() {
    if (!$scope.event.instructor_ids.length) {
      $scope.event.errors.instructor = ['Please select at least one trainer'];
      flash.error = 'Update failed. Please fix the errors below';
      return;
    }
    $scope.isLoading = true;
    return params.save({
      event: $scope.event
    }).then(function(response) {
      return $modalInstance.close(true);
    }, function(response) {
      $scope.event.errors = response.errors;
      return $scope.isLoading = false;
    });
  };
}]);
